import { Card, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { flattenMenuLeaves } from "@/routes/menuMeta";

export function ModulePlaceholderPage() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const leaf = flattenMenuLeaves().find((l) => l.path === pathname);
  const title = leaf ? t(leaf.labelKey) : pathname;

  return (
    <Card title={`${title} · ${t("placeholder.title")}`}>
      <Typography.Paragraph>{t("placeholder.desc")}</Typography.Paragraph>
    </Card>
  );
}
